import { useContext } from 'react';
import { StockCountZonesContext, StockCountZonesContextValues } from '../../contexts/StockCountZonesContext';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const StockCountZonesDeleteCategoriesModal = () => {
  const { t,
    isCategoryDeleteModalOpen,
    handleClose,
    deleteCategories,
    categoryIdToDelete,
    categoryData,
  } = useContext(StockCountZonesContext) as StockCountZonesContextValues;

  const handleConfirmDelete = (selectedCategoryIds: number[]) => {
    const updatedCategories = categoryData.filter(cat => !selectedCategoryIds.includes(cat.id ?? 0));
    deleteCategories(updatedCategories, selectedCategoryIds);
  };

  const handleConfirm = () => {
    if (categoryIdToDelete === undefined) {
      const deletedCategoryIds = categoryData
        .map(c => c.id)
        .filter((id): id is number => Boolean(id));
      handleConfirmDelete(deletedCategoryIds);
    } else {
      handleConfirmDelete([categoryIdToDelete]);
    }
  };

  return (
    <Dialog open={isCategoryDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('categories.deleteTitle')}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
            color: (theme) => theme.palette.custom.gray[800],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>{t('categories.deleteConfirm')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}>
          {t('modals.cancel')}
        </Button>
        <Button variant="bad"
          size='lg'
          onClick={handleConfirm}>
          {t('modals.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockCountZonesDeleteCategoriesModal;